export { PreFooterCTABlock } from './component'

import { MVPColorIdTokenType } from 'marketing-site/src/mvp/library/utils/constants/color-tokens'
import { Document } from '@contentful/rich-text-types'
import { IProps as ICTALink } from 'marketing-site/src/sass-components/library/elements/CTALink'
import { ReactElement } from 'react'

export interface IProps {
  eyebrow?: string
  title: string
  subhead?: string
  linkText?: ICTALink
  cta?: () => ReactElement
  ctaContentType?: 'ctaLink' | 'signupCta' | 'twoCtAsHeroElement'
  ctas: ReactElement[]
  checkmarks?: Document
  width?: 'inset' | 'full-width'
  backgroundColor?: MVPColorIdTokenType
}
